<template>
  <div>
    <h3 class="mb-15">
      Compétences professionnelles
    </h3>
    <div class="flex flex-col space-y-5">
      <div
        v-for="(compPro, iPro) in criterions"
        :key="iPro"
        class="flex flex-col space-y-2.5"
      >
        <div
          class="mr-2 pt-4"
          v-if="iPro > 0 || criterions.length > 1"
        >
          <delete-button
            @del="deleteCompetence(iPro)"
            libelle="Suprimer la compétence"
          />
        </div>
        <div
          id="competencesProForm"
          class="grid grid-cols-4 gap-4"
        >
          <div class="col-span-full md:col-span-2 lg:col-span-1">
            <input-select
              :name="'categoriesPro' + iPro"
              libelle="Poste de travail"
              :datas="referentiel"
              @input="
                (newValue) => {
                  if (!freezeDatas) getDatas('domaines', iPro, newValue);
                }
              "
              :value-is-object="true"
              :value="compPro.values.categories"
            />
          </div>
          <div class="col-span-full md:col-span-2 lg:col-span-1">
            <input-select
              :name="'domainesPro' + iPro"
              libelle="Activité"
              :datas="criterions[iPro].datas.domaines"
              @input="
                (newValue) => {
                  if (!freezeDatas) getDatas('competences', iPro, newValue);
                }
              "
              :value="compPro.values.domaines"
              :value-is-object="true"
            />
          </div>
          <div class="col-span-full md:col-span-2 lg:col-span-1">
            <multiple-select
              :name="'competencesPro' + iPro"
              libelle="Compétences"
              :datas="compPro.datas.competences"
              @input="
                (newValue) => {
                  if (!freezeDatas) setSearching('competences', iPro, newValue);
                }
              "
              :value="compPro.values.competences"
              :value-is-object="true"
            />
          </div>
          <div class="col-span-full md:col-span-2 lg:col-span-1">
            <multiple-select
              :name="'niveauxPro' + iPro"
              libelle="Niveau (minimum)"
              :datas="compPro.datas.niveaux"
              @input="
                (newValue) => {
                  if (!freezeDatas) setSearching('niveaux', iPro, newValue);
                }
              "
              :value="compPro.values.niveaux"
              :value-is-object="true"
            />
          </div>
        </div>
        <div
          id="tagsCompPro"
          class="flex flex-wrap space-y-2.5 items-baseline"
        >
          <tag
            v-if="Object.values(compPro.values.categories).length > 0"
            :libelle="compPro.values.categories.value"
            theme-color="indigo"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="setSearching('categories', iPro, {})"
            class="mr-2.5"
          />
          <tag
            v-if="Object.values(compPro.values.domaines).length > 0"
            :libelle="compPro.values.domaines.value"
            theme-color="pink"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="setSearching('domaines', iPro, {})"
            class="mr-2.5"
          />

          <tag
            v-for="(comp, icomp) in compPro.values.competences"
            :key="comp.value + '-' + icomp"
            :libelle="comp.value"
            theme-color="teal"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="deleteTheCompetence(iPro, icomp)"
            class="mr-2.5"
          />

          <tag
            v-for="(niveau, iniveau) in compPro.values.niveaux"
            :key="niveau.value + '-' + iniveau"
            :libelle="niveau.value"
            theme-color="orange"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="deleteTheNiveau(iniveau, icomp)"
            class="mr-2.5"
          />
        </div>
      </div>
      <div id="addCompProButton">
        <add-button
          class="hidden sm:flex"
          libelle="Ajouter une compétence professionnelle"
          @add="addCompetence"
        />
        <add-button
          class="sm:hidden"
          libelle=""
          @add="addCompetence"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import axios from './../../../api';

import InputSelect from './../../../components/Inputs/InputSelect.vue';
import MultipleSelect from './../../../components/Inputs/MultipleSelect.vue';
import AddButton from './../../../components/Inputs/AddButton.vue';
import Tag from './../../../components/Tag.vue';
import DeleteButton from './../../../components/Inputs/DeleteButton.vue';

import Constants from './../../../constants';

export default {
  name: 'SearchCompetencesProfesionnelles',

  components: {
    InputSelect,
    MultipleSelect,
    AddButton,
    Tag,
    DeleteButton,
  },

  data() {
    return {
      freezeDatas: false,
      competence: '',
      competences: [],
      selectedResults: [],
      isSearchingCompetence: false,
      isSuggestionsListDisplayed: false,
      doneTypingInterval: 500,
      constants: Constants,
    };
  },

  computed: {
    ...mapGetters({
      referentiels: 'rechercheCompetences/referentiels',
      searching: 'rechercheCompetences/searching',
    }),

    typeCompetence() {
      return Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES;
    },

    referentiel() {
      return this.referentiels[this.typeCompetence];
    },

    criterions() {
      return this.searching[this.typeCompetence];
    },
  },

  methods: {
    ...mapMutations({
      SET_SEARCHING: 'rechercheCompetences/SET_SEARCHING',
    }),

    /**
     * Add an empty competence personnelle filter
     */
    addCompetence() {
      this.searching[this.typeCompetence].push({
        datas: { domaines: [], competences: [], niveaux: [] },
        values: { categories: {}, domaines: {}, competences: [], niveaux: [] },
      });
    },

    /**
     * Delete a competence personnelle filter at "index" position
     * @param Number index
     */
    async deleteCompetence(index) {
      this.freezeDatas = true;
      await this.searching[this.typeCompetence].splice(index, 1);

      setTimeout(() => {
        this.freezeDatas = false;
      }, 500);
    },

    /**
     * According to filter field type, call method to reset next fields
     * @param String typeSearch
     * @param Number index
     * @param Object item
     */
    setSearching(typeSearch, index, item) {
      switch (typeSearch) {
      case 'categories':
        this.setSearchingCategories(index, item);
        break;

      case 'domaines':
        this.setSearchingDomaines(index, item);
        break;

      case 'competences':
        this.setSearchingCompetences(index, item);
        break;

      case 'niveaux':
        this.setSearchingNiveaux(index, item);
        break;

      default:
        break;
      }
    },

    /**
     * When change categorie value, reset all other fields
     * @param Number index
     * @param Object item
     * @param Boolean selfReset
     */
    setSearchingCategories(index, item) {
      this.searching[this.typeCompetence][index].values.categories = item;

      if (Object.keys(item).length > 0) {
        this.searching[this.typeCompetence][
          index
        ].values.categories.isSheet = true;
      }

      this.setSearchingDomaines(index, {}, true);
      this.setSearchingCompetences(index, [], true);
    },

    /**
     * reset competences and niveaux after choose a domaine, and put empty array value to domaines field
     * @param Number index
     * @param Object item
     * @param Boolean selfReset
     */
    setSearchingDomaines(index, item, selfReset = false) {
      this.searching[this.typeCompetence][index].values.domaines = item;

      if (
        (item === {} ||
          Object.values(item).length === 0 ||
          item.length === 0) &&
        selfReset
      ) {
        this.searching[this.typeCompetence][index].datas.domaines = [];
      }

      this.setSearchingCompetences(index, [], true);
    },

    /**
     * reset niveaux after choose a competence, and put empty array value to competence field
     * @param Number index
     * @param Object item
     * @param Boolean selfReset
     */
    setSearchingCompetences(index, item, selfReset = false) {
      this.searching[this.typeCompetence][index].values.competences = item;

      if (
        (item === {} ||
          Object.values(item).length === 0 ||
          item.length === 0) &&
        selfReset
      ) {
        this.searching[this.typeCompetence][index].datas.competences = [];
      }
    },

    /**
     * put empty array value to niveaux field
     * @param Number index
     * @param Object item
     * @param Boolean selfReset
     */
    setSearchingNiveaux(index, item, selfReset = false) {
      this.searching[this.typeCompetence][index].values.niveaux = item;

      if (
        (item === {} ||
          Object.values(item).length === 0 ||
          item.length === 0) &&
        selfReset
      ) {
        this.searching[this.typeCompetence][index].datas.niveaux = [];
      }
    },

    /**
     * According to filter field type, call method to generate next fields datas
     * @param String typeData
     * @param Number index
     * @param Object item
     */
    getDatas(typeData, index, item) {
      switch (typeData) {
      case 'domaines':
        this.getDomaines(index, item);
        break;

      case 'competences':
        this.getCompetences(index, item);
        break;

      case 'niveaux':
        this.getNiveaux(index, item);
        break;

      default:
        break;
      }
    },

    /**
     * Reset all fields (other than category) and load domaines
     * @param Number index
     * @param Object newCat
     */
    async getDomaines(index, newCat) {
      this.setSearchingCategories(index, newCat);
      if (!newCat.id || newCat === '' || Object.values(newCat).length === 0) {
        //Nothing if empty value
        return;
      }

      await axios
        .get('api/recherche/loadDomaines/' + newCat.id + '/' + true)
        .then((response) => {
          this.searching[this.typeCompetence][index].datas.domaines =
            response.data;
        });

      await axios
        .get(
          'api/recherche/loadNiveaux/' +
            newCat.id +
            '/' +
            parseInt(-1) +
            '/' +
            parseInt(-1) +
            '/' +
            true
        )
        .then((response) => {
          this.searching[this.typeCompetence][index].datas.niveaux =
            response.data;
        });
    },

    /**
     * Reset all fields before competences (domaine and category) and load competences
     * @param Number index
     * @param Object newCat
     */
    async getCompetences(index, newDom) {
      this.setSearchingDomaines(index, newDom);
      if (newDom === '' || Object.values(newDom).length === 0) {
        //Nothing if empty value
        return;
      }

      await axios
        .get(
          'api/recherche/loadCompetences/' +
            this.searching[this.typeCompetence][index].values.categories.id +
            '/' +
            parseInt(newDom.position) +
            '/' +
            true
        )
        .then((response) => {
          this.searching[this.typeCompetence][index].datas.competences =
            response.data;
        });
    },

    /**
     * Reset all fields before niveaux (category, domaine and category) and load Niveaux
     * @param Number index
     * @param Object newCat
     */
    async getNiveaux(index, newComp) {
      this.setSearchingCompetences(index, newComp);
      if (
        newComp === '' ||
        Object.values(newComp).length === 0 ||
        newComp.length === 0
      ) {
        //Nothing if empty value
        return;
      }

      await axios
        .get(
          'api/recherche/loadNiveaux/' +
            this.searching[this.typeCompetence][index].values.categories.id +
            '/' +
            parseInt(
              this.searching[this.typeCompetence][index].values.domaines
                .position
            ) +
            '/' +
            parseInt(newComp.position) +
            '/' +
            true
        )
        .then((response) => {
          this.searching[this.typeCompetence][index].datas.niveaux =
            response.data;
        });
    },

    /**
     * Delete only one competence among multi selection
     * @param Number indexCriterions
     * @param Number indexCompetence
     */
    deleteTheCompetence(indexCriterions, indexCompetence) {
      this.searching[this.typeCompetence][
        indexCriterions
      ].values.competences.splice(indexCompetence, 1);
    },

    /**
     * Delete only one niveau among multi selection
     * @param Number indexCriterions
     * @param Number indexNiveau
     */
    deleteTheNiveau(indexCriterions, indexNiveau) {
      this.searching[this.typeCompetence][
        indexCriterions
      ].values.niveaux.splice(indexNiveau, 1);
    },
  },

  watch: {
    /**
     * Call the API only after a set amount of time after search has changed to avoid sending unnecessary requests
     */
    competence() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(
        this.getSuggestionCompetences,
        this.doneTypingInterval
      );
    },
  },
};
</script>
